module.exports = new __parcel__URL__("shop_etherorc_allies_image.e9f72737.png").toString();